"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOilonInput = getOilonInput;
exports.parseCalculationCasesResults = parseCalculationCasesResults;
const property_1 = require("@genesys/property");
const known_properties_1 = require("./known-properties");
function getOilonInput(state) {
    const getIntValue = (name, pvs) => property_1.PropertyValue.getInteger(property_1.PropertyValueSet.getValue(name, pvs));
    const getStringValue = (name, pvs) => property_1.PropertyValue.toString(property_1.PropertyValueSet.getValue(name, pvs));
    const configPvs = state.propertiesSelectors["config"];
    const calculationCasesPvs = Object.entries(state.propertiesSelectors)
        .filter(([id, _v]) => id.startsWith("case"))
        .map(([_id, pvs]) => pvs);
    const calulationCases = calculationCasesPvs.map(pvs => {
        var _a;
        return ({
            name: (_a = property_1.PropertyValueSet.getText(known_properties_1.name, pvs)) !== null && _a !== void 0 ? _a : "",
            highTemperatureStageInUse: getIntValue(known_properties_1.highTemperatureStageInUse, pvs) === 1,
            highTemperatureStageCondenserInletTemperature: getStringValue(known_properties_1.highTemperatureStageCondenserInletTemperature, pvs),
            highTemperatureStageCondenserOutletTemperature: getStringValue(known_properties_1.highTemperatureStageCondenserOutletTemperature, pvs),
            highTemperatureStageHeatingCapacityRequirement: getStringValue(known_properties_1.highTemperatureStageHeatingCapacityRequirement, pvs),
            highTemperatureStageCondenserPipeLength: getStringValue(known_properties_1.highTemperatureStageCondenserPipeLength, pvs),
            lowTemperatureStageCondenserInletTemperature: getStringValue(known_properties_1.lowTemperatureStageCondenserInletTemperature, pvs),
            lowTemperatureStageCondenserOutletTemperature: getStringValue(known_properties_1.lowTemperatureStageCondenserOutletTemperature, pvs),
            lowTemperatureStageCondenserPipeLength: getStringValue(known_properties_1.lowTemperatureStageCondenserPipeLength, pvs),
            lowTemperatureStageEvaporatorInletTemperature: getStringValue(known_properties_1.lowTemperatureStageEvaporatorInletTemperature, pvs),
            lowTemperatureStageEvaporatorOutletTemperature: getStringValue(known_properties_1.lowTemperatureStageEvaporatorOutletTemperature, pvs),
            lowTemperatureStageEvaporatorPipeLength: getStringValue(known_properties_1.lowTemperatureStageEvaporatorPipeLength, pvs),
            lowTemperatureStageHeatingCapacityRequirement: getStringValue(known_properties_1.lowTemperatureStageHeatingCapacityRequirement, pvs),
            lowTemperatureStageCoolingCapacityRequirement: getStringValue(known_properties_1.lowTemperatureStageCoolingCapacityRequirement, pvs),
            wetAirDumpingStreamOutletTemperature: getStringValue(known_properties_1.wetAirDumpingStreamOutletTemperature, pvs)
        });
    });
    const oilonInput = {
        reference: "oilon-tool",
        heatPumpConfigurationType: getIntValue(known_properties_1.heatPumpConfigurationType, configPvs),
        wetAirAvailableAsHeatSource: getIntValue(known_properties_1.wetAirAvailableAsHeatSource, configPvs) === 1,
        wetAirAvailableAsHeatSink: getIntValue(known_properties_1.wetAirAvailableAsHeatSink, configPvs) === 1,
        evaporatorFluidType: getIntValue(known_properties_1.evaporatorFluidType, configPvs),
        evaporatorFluidConcentration: getStringValue(known_properties_1.evaporatorFluidConcentration, configPvs),
        calculationCases: calulationCases
    };
    return oilonInput;
}
function parseCalculationCasesResults(calculationCases) {
    if (!calculationCases) {
        return [];
    }
    const caseResults = calculationCases.map(calculationCase => {
        return Object.entries(calculationCase).reduce((soFar, [propertyName, value]) => {
            if (propertyName === "name") {
                return property_1.PropertyValueSet.setText("p_OIL_" + propertyName, value, soFar);
            }
            else {
                return property_1.PropertyValueSet.set("p_OIL_" + propertyName, property_1.PropertyValue.fromString(value), soFar);
            }
        }, property_1.PropertyValueSet.Empty);
    });
    return caseResults;
}
//# sourceMappingURL=functions.js.map